const CONSTANTS = {
	CIBIL_FLOW_JOB_ID: [351, 377]
};

export default CONSTANTS;